'use strict';

var _ = require('lodash');
function AdjustDatesComponentController($scope) {
  $scope.adjustedDates = [];
  $scope.removeAdjustedDates = function (adjustedDateToDelete) {
    if ($scope.disabledDates) {
      return;
    }
    _.remove($scope.adjustedDates, function (adjustedDate) {
      return adjustedDate.$$hashKey === adjustedDateToDelete.$$hashKey;
    });
  };
  $scope.addAdjustedDates = function () {
    if ($scope.disabledDates) {
      return;
    }
    $scope.adjustedDates.push(initNewRow());
  };
  $scope.showIfExists = function (item, property) {
    return _.has(item, property);
  };
  $scope.initialize = function () {
    if ($scope.settings.options && $scope.settings.options.length) {
      var selectedOptions = _.find($scope.settings.options, {
        "default": true
      }) || $scope.settings.options[_.first(_.keys($scope.settings.options))];
      $scope.settings.selectedAdjustment = selectedOptions.value;
      $scope.adjustedDates = _.get($scope, ['userAdjustedDates', selectedOptions.value], []);
      return;
    }
  };
  $scope.isAdjustedDateVisible = function (adjustedDate) {
    if (!$scope.settings.applicableDateRange) {
      return true;
    }
    return adjustedDate.isVisible;
  };
  function initNewRow() {
    return _.chain($scope.settings.fields).split(':').transform(function (result, fieldName) {
      result[fieldName] = null;
      return result;
    }, {}).thru(function (row) {
      if ($scope.settings.applicableDateRange) {
        row.isVisible = true;
      }
      return row;
    }).value();
  }
}
AdjustDatesComponentController.$inject = ['$scope'];
module.exports = AdjustDatesComponentController;